import React, { useState } from 'react';

import { Grid, Button, Modal, TextField, Collapse } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Alert } from '@material-ui/lab';
import { Box, Typography } from '@mui/material';

import { COLOR_PRIMARY, BACKGROUND_COLOR } from 'src/const';
import { callApi } from 'src/core/callApi';
import { SaveROISimulationModalPropTypes } from 'src/interfaces/iproptypes';

const useStyles = makeStyles((theme: Theme) => ({
  modalContainer: {
    width: '40%',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    borderRadius: 20,
    backgroundColor: BACKGROUND_COLOR,
    [theme.breakpoints.down(900)]: {
      width: '60%',
    },
    [theme.breakpoints.down(500)]: {
      width: '80%',
    },
    animation: 'fade-scale-in 0.3s ease forwards',
  },
  textField: {
    marginTop: 10,
  },
  button: {
    borderRadius: 100,
    padding: '5px auto',
    outline: 'none',
    textTransform: 'capitalize',
    marginTop: 20,
    width: '45%',
    fontSize: '18px',
    fontWeight: 'bold',
  },
}));

const SaveROISimulationModal = ({
  saveSnapshotModalOpen,
  setSaveSnapshotModalOpen,
  takeSnapshot,
  snapshotObj,
  setSnapshotObj,
}: SaveROISimulationModalPropTypes) => {
  const classes = useStyles();

  const [alert, setAlert] = useState<boolean>(false);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const key = event.target.name;
    let value: string | number = event.target.value;
    if (key === 'size') {
      value = value === '' || parseInt(value) === NaN ? 0 : parseInt(value);
    }
    setSnapshotObj({
      ...snapshotObj,
      [key]: value,
    });
  };

  const handleSubmit = () => {
    if (snapshotObj.size && snapshotObj.name) {
      setSaveSnapshotModalOpen(false);
      takeSnapshot();
    } else {
      setAlert(true);
    }
  };

  return (
    <>
      <Modal open={saveSnapshotModalOpen}>
        <Grid
          container
          direction="column"
          alignItems="center"
          justify="center"
          style={{ minHeight: '100vh' }}
        >
          <Grid
            container
            item
            direction="column"
            justify="center"
            alignItems="center"
            xs={12}
            className={classes.modalContainer}
          >
            <Typography variant="h5">Save Simulation Snapshot</Typography>

            <TextField
              id="name"
              fullWidth
              required
              error={!snapshotObj.name}
              autoFocus={true}
              label="Name"
              variant="standard"
              size="small"
              type="text"
              className={classes.textField}
              name="name"
              value={snapshotObj.name}
              onChange={handleInputChange}
            />
            <TextField
              id="link"
              fullWidth
              label="Link"
              variant="standard"
              size="small"
              type="text"
              className={classes.textField}
              name="link"
              value={snapshotObj.link}
              onChange={handleInputChange}
            />
            <TextField
              id="size"
              fullWidth
              required
              error={!snapshotObj.size}
              label="Size"
              variant="standard"
              size="small"
              type="tel"
              className={classes.textField}
              name="size"
              value={snapshotObj.size === 0 ? '' : snapshotObj.size}
              onChange={handleInputChange}
              InputProps={{
                endAdornment: <Box ml={1}>&#13217;</Box>,
              }}
            />
            <TextField
              id="note"
              fullWidth
              label="Note"
              variant="standard"
              size="small"
              type="text"
              className={classes.textField}
              name="note"
              value={snapshotObj.note}
              onChange={handleInputChange}
            />

            <Grid container item direction="row" justify="space-between" alignItems="center">
              <Button
                size="small"
                variant="contained"
                className={classes.button}
                style={{
                  background: '#fff',
                  color: COLOR_PRIMARY,
                  border: `1px solid ${COLOR_PRIMARY}`,
                }}
                onClick={() => setSaveSnapshotModalOpen(false)}
              >
                Cancel
              </Button>
              <Button
                size="small"
                variant="contained"
                className={classes.button}
                style={{
                  background: COLOR_PRIMARY,
                  color: '#fff',
                  border: 'none',
                }}
                onClick={handleSubmit}
              >
                Continue
              </Button>
            </Grid>

            <Collapse in={alert}>
              <Alert severity="error" style={{ marginTop: 20 }}>
                Required fields are missing.
              </Alert>
            </Collapse>
          </Grid>
        </Grid>
      </Modal>
    </>
  );
};

export default SaveROISimulationModal;
